<template>
    <button
        :class="['menu-item', {'has-notification': notification}]"
        :aria-current="ariaCurrentState"
    >
        <div class="menu-item__icon">
            <span class="menu-item__pastille"></span>
            <component :is="props.iconName" :weight="props.iconWeight"></component>
        </div>
        <span :class="['menu-item__title', { 'sr-only': !isExtended() || props.title === 'Menu' }]">{{title}}</span>
        <span v-if="notification" class="sr-only">- Nouvelles notifications</span>
    </button>
</template>

<script setup lang="ts">
    import { AriaAttributes, type Component } from 'vue';
    import useMenuState from "@/composables/useMenuState";
    const { isExtended } = useMenuState();

    const props = defineProps<{
        iconName: Component
        iconWeight: string
        notification: boolean
        title: string
        ariaCurrentState?: AriaAttributes['aria-current']
    }>();
</script>
